import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
import axios from 'axios';
import Cookies from 'universal-cookie'; 
import Frame from 'react-frame-component';
import {BeautifulCircleIcon} from './BeautifulCircleIcon';
import {DesktopRedDesign} from './DesktopRedDesign';


export class RedDesign extends React.Component {




    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div style={{marginTop: '5em'}} className='redDesignAndView'>
                <div className='redDesignAndView__viewBlock' >
                    <div className='redDesignAndView__viewBlock_changeMobileDesktopBlock'>
                        <div
                        onClick={(e) => {
                            this.props.changeFrameView('desktop')}
                        }
                         className={this.props.frameViewType == 'desktop' ?
                          'redDesignAndView__viewBlock_changeMobileDesktopBlock_chooseBlock_chosen redDesignAndView__viewBlock_changeMobileDesktopBlock_chooseBlock redDesignAndView__viewBlock_changeMobileDesktopBlock_desktopChoose' : 'redDesignAndView__viewBlock_changeMobileDesktopBlock_chooseBlock redDesignAndView__viewBlock_changeMobileDesktopBlock_desktopChoose' }>
                                                <svg
                            xmlns="http://www.w3.org/2000/svg"
                           
                            viewBox="0 0 18.643 12.428"
                            >
                            <path
                            fill='#9197B3'
                                d="M3.107 5.554h12.428v7.768H3.107m12.428 1.554a1.554 1.554 0 001.554-1.554V5.554A1.553 1.553 0 0015.535 4H3.107a1.548 1.548 0 00-1.553 1.554v7.768a1.554 1.554 0 001.554 1.554H0v1.554h18.642v-1.555z"
                                className="cls-1"
                                transform="translate(0 -4)"
                            ></path>
                            </svg>
                        </div>
                        <div 
                          onClick={(e) => {
                            this.props.changeFrameView('mobile')}
                        }
                        className={this.props.frameViewType == 'mobile' ? 
                        'redDesignAndView__viewBlock_changeMobileDesktopBlock_chooseBlock_chosen redDesignAndView__viewBlock_changeMobileDesktopBlock_chooseBlock redDesignAndView__viewBlock_changeMobileDesktopBlock_desktopChoose' : 'redDesignAndView__viewBlock_changeMobileDesktopBlock_chooseBlock redDesignAndView__viewBlock_changeMobileDesktopBlock_mobileChoose' }>
                                                <svg
                            xmlns="http://www.w3.org/2000/svg"
                             
                            viewBox="0 0 12.668 19.907"
                            >
                            <path
                            fill='#9197B3'
                                d="M16.084 16.382h-9.5V3.715h9.5M13.144 19.1h-3.62v-.9h3.619M14.953 1H7.715A2.715 2.715 0 005 3.715v14.477a2.715 2.715 0 002.715 2.715h7.239a2.715 2.715 0 002.715-2.715V3.715A2.715 2.715 0 0014.953 1z"
                                className="cls-1"
                                transform="translate(-5 -1)"
                            ></path>
                            </svg>
                        </div>
                    
    
                    </div>
                
                <Frame scrolling='no' initialContent={this.props.initialContent()} height={this.props.frameHeight} width={this.props.frameWidth}>
                <div className="reset-this">
            <div className={ 
             this.props.show   ? 
            "WidgetTemplate_bodyBackground " 
            :
             "WidgetTemplate_bodyBackground"}></div>
            <div  ref={(node) => {
      if (node) {
        node.style.setProperty("overflow", "hidden", "important");
      }
    }}          className={ 
             this.props.show   ? 
            "WidgetTemplate_widget" 
            :
             "WidgetTemplate_widget"}>    
                <div className="WidgetTemplate_widget_inner">
                    <div style={{'background': this.props.bgMobileColorHex, 'opacity': this.props.bgMobileOpacity}} className='WidgetTemplate_mobileBg'></div>
                <svg
      xmlns="http://www.w3.org/2000/svg"
      width="938"
      height="474"
      fill="none"
      viewBox="0 0 469 237"
    >
      <g clipPath="url(#clip0_779_2380)">
        <path fillOpacity={this.props.bg2Opacity} fill={this.props.bg2ColorHex} d="M0 0H938V474H0z"></path>
        <path
          fill={this.props.bg1ColorHex}
          fillOpacity={this.props.bg1Opacity}
          d="M-105 0.476H530.936V264.94H-105z"
          transform="rotate(-17.807 -105 .476)"
        ></path>
        <rect
          width="67.478"
          height="67.478"
          x="287"
          y="137.522"
          fill={this.props.btnColorHex}
          rx="9.526"
        ></rect>
      </g>
      <defs>
        <clipPath id="clip0_779_2380">
          <path fill="#fff" d="M0 0H938V474H0z"></path>
        </clipPath>
      </defs>
    </svg>
                    <img onClick={(e) => {
                        this.resetState() 
                        this.props.setShowPreview(e, !true)
                    }
                    } id="doClose" className="WidgetTemplate_widgetCloseIcon" src="https://clientsaver.ru/static/css/close-icon.svg" />
                    <div style={{"background": 'rgba(' + this.props.bgMobileColor.r+', '+this.props.bgMobileColor.g+', '+this.props.bgMobileColor.b+', '+this.props.bgMobileColor.a+')'} }
    className="WidgetTemplate_widgetCloseIcon WidgetTemplate_widgetCloseIcon_mobile">

                                            <div ref={(node) => {
      if (node) {
        node.style.setProperty("background", this.props.btnTextColorHex, "important");
      }
    }}  style={{'width': '100%', 'height': '100%'}}   ></div>
                        <svg
                                       
                                        xmlns="http://www.w3.org/2000/svg"
                                        x="0"
                                        y="0"
                                        enableBackground="new 0 0 512 512"
                                        version="1.1"
                                        viewBox="0 0 512 512"
                                        xmlSpace="preserve"
                                        >
                                        <path
                                            fill={this.props.btnColorHex}
                                            d="M0 0v512h512V0H0zm327.115 365.904L256 294.789l-71.115 71.115-38.789-38.789L217.211 256l-71.115-71.115 38.789-38.789L256 217.211l71.115-71.115 38.789 38.789L294.789 256l71.115 71.115-38.789 38.789z"
                                        ></path>
                        </svg>
                    </div>
                    
                <div  className='WidgetTemplate_rightSide'>
                    <img  className='WidgetTemplate_desktopImage' src={this.props.big_img_src} />
                    {this.props.small_img_src == null ? 
                    null
                    :
                    <img  className="WidgetTemplate_mobileImage" src={this.props.small_img_src} />}
                </div>
                <div  className='WidgetTemplate_leftSide'>
                    <div  className='WidgetTemplate_leftSide_inner'>
                    <div className="WidgetTemplate_leftSide_mainBlock">
                        
                            <div ref={this.props.refFirstStage} className="WidgetTemplate_firstStage" >
                                <h1   ref={(node) => {
      if (node) {
        node.style.setProperty("color", this.props.h1ColorHex, "important");
      }
    }}   ><span className="h1_span">{this.props.header_text}</span></h1>
                                <h2 ref={(node) => {
      if (node) {
        node.style.setProperty("color", this.props.h2ColorHex, "important");
      }
    }}  > <span className="h2_span">{this.props.main_text}</span></h2>                    
                                <div  className='WidgetTemplate_buttonBlock'> 
                                <a  style={{'background' : this.props.btnColorHex, 'color':this.props.btnTextColorHex}} onClick={(e) => {
                                    e.preventDefault();
                                }} href='#' className="WidgetTemplate_firstStageButton" > Получить</a>
                                </div>
                                <div style={{'color': this.props.h2ColorHex}} className="WidgetTemplate_poweredByBlock">
                                    <span className="WidgetTemplate_poweredByBlock_span ">
                                    Создано на <a style={{color: this.props.logoColorHex}} onClick={(e) => {
                                    e.preventDefault();
                                }} href="#">clientsaver</a>    
                                    </span>
                                </div>
                            </div>
                        
                        
                        
                           
                        
                        
                           
                         
                        
                            
                                       
                    </div>            
                    </div>        
                    </div>   
                     </div>
                     </div>
                      </div>
                </Frame>
                </div>
               
                {/* 
                <SketchPicker
                color={ this.state.btnColor }
                onChange ={ this.handleChangeComplete }
                 /> 
                 */}
                
                <DesktopRedDesign 
                bgMobileOpacity={this.props.bgMobileOpacity} 
                colorPickerBgMobileColorRef={this.props.colorPickerBgMobileColorRef}
                showColorPickerBgMobileColor={this.props.showColorPickerBgMobileColor}
                bgMobileColor={this.props.bgMobileColor}
                bgMobileColorHex={this.props.bgMobileColorHex}


                showColorPicker={this.props.showColorPicker}
                bg2Opacity={this.props.bg2Opacity} 
                initialContent={this.props.initialContent}
                bg2ColorHex={this.props.bg2ColorHex}
                bg1ColorHex={this.props.bg1ColorHex}
                bg1Opacity={this.props.bg1Opacity}
                btnColorHex={this.props.btnColorHex}
                big_img_src={this.props.big_img_src}
                small_img_src={this.props.small_img_src}
                refFirstStage={this.props.refFirstStage}
                h1ColorHex={this.props.h1ColorHex}
                h1Color={this.props.h1Color}
                h2ColorHex={this.props.h2ColorHex}
                header_text={this.props.header_text}
                main_text={this.props.main_text}
                logoColorHex={this.props.logoColorHex}
                btnTextColorHex={this.props.btnTextColorHex}
                setDefault={this.props.setDefault}
                colorPickerBtnColorRef={this.props.colorPickerBtnColorRef}
                showColorPickerBtnColor={this.props.showColorPickerBtnColor}
                btnColor={this.props.btnColor}
                handleChangeComplete={this.props.handleChangeComplete}
                colorPickerBg1ColorRef={this.props.colorPickerBg1ColorRef}
                showColorPickerBg1Color={this.props.showColorPickerBg1Color}
                bg1Color={this.props.bg1Color}
                
                colorPickerBg2ColorRef={this.props.colorPickerBg2ColorRef}
                showColorPickerBg2Color={this.props.showColorPickerBg2Color}
                bg2Color={this.props.bg2Color}

                colorPickerBtnTextColorRef={this.props.colorPickerBtnTextColorRef}
                showColorPickerBtnTextColor = {this.props.showColorPickerBtnTextColor}
                btnTextColor={this.props.btnTextColor}
                

                colorPickerH1ColorRef={this.props.colorPickerH1ColorRef}
                showColorPickerH1Color={this.props.showColorPickerH1Color}

                colorPickerH2ColorRef={this.props.colorPickerH2ColorRef}
                showColorPickerH2Color={this.props.showColorPickerH2Color}
                h2Color={this.props.h2Color}

                colorPickerLogoColorRef={this.props.colorPickerLogoColorRef}
                showColorPickerLogoColor={this.props.showColorPickerLogoColor}
                logoColor={this.props.logoColor}

                />
                </div>


        )
    }
}














